import { configModule } from './config/config';
import { exceptionHandlerServiceModule } from '../../shared/app/services/exception-handler/exception-handler';
import { activateOnScrollComponentModule } from '../../shared/app/components/activate-on-scroll/activate-on-scroll';
import { scrollToComponentModule } from '../../shared/app/components/scroll-to/scroll-to';
import { tooltipComponentModule } from '../../shared/app/components/tooltip/tooltip';
import { trackerServiceModule } from '../../shared/app/services/tracker-service/tracker-service';
import { loadingBarModule } from '../../shared/app/vendor/loading-bar-module';
import {
  ngAnimateModule,
  ngAriaModule,
  ngSanitizeModule,
} from '../../shared/app/vendor/angular-modules';
import { stickyHeaderComponentModule } from '../../shared/app/components/sticky-header/sticky-header';
import { cookieWarningServiceModule } from '../../shared/app/services/cookie-warning-service/cookie-warning-service';
import { kbRedirectComponentModule } from './components/kb-redirect/kb-redirect';

angular
  .module('qualified', [
    // general includes
    ngAriaModule,
    ngSanitizeModule,
    ngAnimateModule,
    loadingBarModule,

    // configuration modules
    configModule,

    // remote exception handling
    exceptionHandlerServiceModule,

    // modules in use on the kb
    activateOnScrollComponentModule,
    scrollToComponentModule,
    tooltipComponentModule,
    stickyHeaderComponentModule,
    cookieWarningServiceModule,
    kbRedirectComponentModule,

    // analytics
    trackerServiceModule,
  ])
  .config(function ($locationProvider) {
    // we set the base tag _within_ the angular app, because it breaks regular links
    const base = document.createElement('base');
    base.href = window.config.kbRoute + '/';
    document.getElementsByTagName('head')[0].appendChild(base);

    $locationProvider.html5Mode(true);
  })

  .run(function ($document) {
    angular.forEach($document[0].querySelectorAll('a'), function (a) {
      let $a = angular.element(a);
      if (/^[#]/.test($a.attr('href'))) {
        // add in scroll-to links for in-page references
        $a.attr('scroll-to', '');
      } else if (!a.target) {
        // force page reloads for everything else
        a.target = '_self';
      }
    });
  })

  .controller('KbAppCtrl', function () {});
